import { useGet } from '@/query/fetchHooks';
import { useParams } from 'react-router-dom';
import AddContentModal from '@/components/AddContentModal/AddContentModal';
import TeamDetailsPage from './TeamDetailsPage/TeamDetailsPage';
import AddCourse from './AddCourse/AddCoures';
import { useState, useContext } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';
import AddCourseLP from './AddCourseLP/AddCourseLP';

function TeamDetails() {
  const { teamId, organisationId } = useParams();
  const [teamInfo, setTeamInfo] = useState<any>(null);
  const [isOpenAddContentModal, setIsOpenAddContentModal] = useState(false);
  const [isOpenAddContent, setIsOpenAddContent] = useState(false);
  const [activeCourse, setActiveCourse] = useState();
  const [activeLP, setActiveLP] = useState();
  const [courseType, setCourseType] = useState();
  const [importProgress, setImportProgress] = useState(false);
  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  const teamResult = useGet(
    `/team/${authUser?.activeOrganisationId}/${teamId}`,
    {
      onSuccess: (result: any) => {
        setTeamInfo(result?.data || {});
      },
    }
  );

  return (
    <div>
      {isOpenAddContent ? (
        <>
          {activeCourse && (
            <AddCourse
              activeCourse={activeCourse}
              setActiveCourse={setActiveCourse}
              setIsOpenAddContent={setIsOpenAddContent}
              teamInfo={teamInfo}
              setIsOpenAddContentModal={setIsOpenAddContentModal}
              activeCourseType={courseType}
            />
          )}
          {activeLP && (
            <AddCourseLP
              activeLP={activeLP}
              setActiveLP={setActiveLP}
              setIsOpenAddContent={setIsOpenAddContent}
              teamInfo={teamInfo}
              setIsOpenAddContentModal={setIsOpenAddContentModal}
              importProgress={importProgress}
            />
          )}
        </>
      ) : (
        <TeamDetailsPage
          teamInfo={teamInfo}
          refetchTeam={teamResult.refetch}
          setIsOpenAddContentModal={setIsOpenAddContentModal}
        />
      )}
      <AddContentModal
        isOpenAddContentModal={isOpenAddContentModal}
        setIsOpenAddContentModal={setIsOpenAddContentModal}
        closeModal={() => setIsOpenAddContentModal(false)}
        setIsOpenAddContent={setIsOpenAddContent}
        setActiveCourse={setActiveCourse}
        activeCourse={activeCourse}
        setCourseType={setCourseType}
        setActiveLP={setActiveLP}
        activeLP={activeLP}
        importProgress={importProgress}
        setImportProgress={setImportProgress}
      />
    </div>
  );
}

export default TeamDetails;
